module.exports = __webpack_public_path__ + "media/images/default-image-84de97ef9bdd5a79cda89322ee57953d.png";